/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_FeelInputs */

const en_body_feel = /** @type {(inputs: Body_FeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body Feel`)
};

const es_body_feel = /** @type {(inputs: Body_FeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sensacion en boca`)
};

/**
* | output |
* | --- |
* | "Body Feel" |
*
* @param {Body_FeelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const body_feel = /** @type {((inputs?: Body_FeelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_FeelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_body_feel(inputs)
	return es_body_feel(inputs)
});